import React from 'react';
import PropTypes from 'prop-types';
import { useChatContext } from '../context/chat-context';
import { getAiSaver, getSiteConfig } from '../../../cms-api/ai';
import { useSiteContext } from '../../../components/site/context/site-context';

const MessageParser = ({ children, actions }) => {

  console.log('MessageParser chat context', useChatContext())

  const {setIsSending, sendMessage, get_template_code, get_site_config_data, createToken, type, config} = useChatContext();

  const { saveTempConfig, getConfigEditData } = useSiteContext();

  const parse = (message) => {

    setIsSending(true);

    getAiSaver().then((response) => {
      console.log(message)
      
      const configData = getConfigEditData();
      const templateAiVersion = configData?.ai?.template_chat?.version || 'v3';
      
      if (message === "/create_code") {

        const send_data = {
          "query": message,
          "cms_token": response.token,
          "template_ai_version": templateAiVersion,
        }

        if (get_template_code != null) {
          send_data.create_code = get_template_code();
        }
        if (get_site_config_data != null) {
          send_data.site_config = get_site_config_data();
        }

        if (type !== "template-simple-v2") {
          send_data.is_create_code = true;
        }

        sendMessage(JSON.stringify(send_data));

        actions.customerDoc()
      } else {

        const send_data = {
          "query": message,
          "cms_token": response.token,
          "is_layout_template": config?.is_layout_template || false,
          "template_ai_version": templateAiVersion,
        }

        if (type === "template-simple-v2") {
          send_data.create_code = get_template_code();
        }

        if (get_template_code != null) {
          send_data.create_code = get_template_code();
        }
        if (get_site_config_data != null) {
          send_data.site_config = get_site_config_data();
        }
        console.log(send_data)
        sendMessage(JSON.stringify(send_data));

        actions.typingMessage({ message: 'Typing...' });
      }

      if (message.includes('hello')) {
        actions.handleHello();
      } else if (message.includes('dog')) {
        actions.handleDog();
      }
    }).catch((error) =>
      console.error('Error getting AI Saver:', error)
    );
  };

  return (
    <div>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          parse,
          actions,
        })
      )}
    </div>
  );
};

export default MessageParser;

MessageParser.propTypes = {
  children: PropTypes.node,
  actions: PropTypes.object,
}
